import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { getClients } from "../../data/clients/repository/ClientsRepository";
import { ClientContext } from "../../context/ClientContext";
import { use } from "react";
import { messages } from "../../utils/Constants";

export function useClients() {
    const {setClient, isCreatedClient, isEditedClient, isDeletedClient, clearSuccess} = useContext(ClientContext);
    const [clients, setClients] = useState([]);
    const [clientTableLineId, setClientTableLineId] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchClients();
        clearSuccess();
    },[]);

    useEffect(() => {
        if (isCreatedClient === true) {
            toast.success(messages.clientCreatedSuccess);
            fetchClients();
            clearSuccess();
        } else if (isCreatedClient === false) {
            toast.error(messages.clientCreatedError);
        }
    },[isCreatedClient]);

    useEffect(() => {
        if (isEditedClient === true) {
            toast.success(messages.clientEditedSuccess);
            fetchClients();
            clearSuccess();
        } else if (isEditedClient === false) {
            toast.error(messages.clientEditedError);
        }
    },[isEditedClient]);

    useEffect(() => {
        if (isDeletedClient === true) {
            toast.success(messages.clientDeletedSuccess);
            fetchClients();
            clearSuccess();
        } else if(isDeletedClient === false) {
            toast.error(messages.clientDeletedError);
        }
    },[isDeletedClient]);

    const fetchClients = async () => {
        try {
            setLoading(true);
            const response = await getClients();
            setClients(response?.clients ?? []);
        } catch (error) {
            toast.error(messages.loadClientsError);
        } finally {
            setLoading(false);
        }
    };

    const handleRowClick = (client) => {
        setClientTableLineId(client.id);
        setClient(client)
    };

    return {
        clients,
        clientTableLineId,
        handleRowClick,
        loading,
        fetchClients
    };
}